import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

export default {
  /**
   * GET `/log/event/event/period/{start}/{end}` — event log satu rentang.
   * SUDAH di-unwrap: yang balik `response.data` (body), jadi jalur bacanya `body.data`
   * dan `body.pagination.totalData`.
   *
   * `status.errorCode` datang dengan HTTP 200, jadi adanya `status` di body udah
   * berarti gagal — pemanggil ngosongin tabel dan nampilin `status.message`
   * (src/views/event/EventLog.vue:322).
   *
   * Query dirakit MANUAL jadi string, bukan lewat `params` axios, karena axios gak bisa
   * ngebentuk `finds[k][]`. Konvensinya: `finds[k]=v` buat nilai tunggal,
   * `finds[k][]=v` diulang buat array, `orders[k]=ASC|DESC`, sisanya key polos. Nilai
   * kosong, null, dan undefined dibuang, dan nilainya TIDAK di-encode.
   *
   * @param {Object} [options]
   * @param {number} options.start unix detik, wajib
   * @param {number} options.end unix detik, wajib dan harus lebih besar dari start
   * @param {Object.<string, string|number|Array>} [options.finds] filter per kolom
   * @param {Object.<string, string>} [options.orders] urutan per kolom
   * @param {Object} [options.params] param polos, mis. `max` dan `page`
   * @returns {Promise<{data: Object[], pagination: import('@/services/_AxiosInstance').ApiPagination, status: import('@/services/_AxiosInstance').ApiStatus}>}
   *   body sudah di-unwrap
   * @throws {Error} kalau start atau end kosong, atau end gak lebih besar dari start
   */
  getEventLogs: async (options = {}) => {
    const {
      start,
      end,
      finds = {},
      orders = {},
      params = {},
    } = options;

    if (!start || !end) {
      throw new Error('start and end timestamps are required');
    }

    if (Number(end) <= Number(start)) {
      throw new Error('The "end" timestamp must be greater than "start" timestamp.');
    }

    const baseUrl = `/log/event/event/period/${start}/${end}`;

    const findsParts = [];
    Object.entries(finds).forEach(([key, value]) => {
      if (value === '' || value === null || value === undefined) return;
      if (Array.isArray(value)) {
        value.forEach((v) => findsParts.push(`finds[${key}][]=${v}`));
      } else {
        findsParts.push(`finds[${key}]=${value}`);
      }
    });

    const ordersParts = [];
    Object.entries(orders).forEach(([key, value]) => {
      if (value === '' || value === null || value === undefined) return;
      ordersParts.push(`orders[${key}]=${value}`);
    });

    const otherParts = [];
    Object.entries(params).forEach(([key, value]) => {
      if (value === '' || value === null || value === undefined) return;
      otherParts.push(`${key}=${value}`);
    });

    const queryString = [...findsParts, ...ordersParts, ...otherParts].join('&');

    const response = await axiosInstance.get(`${baseUrl}?${queryString}`, {
      cancelToken: getNewCancelToken(),
    });
    return response.data;
  },
};
